import React from 'react';
import { Link } from '../../../Elements/Link';
import { Image } from '../../../Media';

export const FooterBottom = ({ legal, payments }) => (
  <>
    <div className='w-full flex flex-col md:flex-row gap-6 pt-4 mt-8 border-t pb-5 md:pt-8 items-center justify-center md:justify-between'>
      <div className='flex space-x-6 md:order-2'>
        {legal?.items?.map((item) => (
          <div className='text-gray-300 hover:text-white'>
            <Link
              {...item}
              label={{ ...item.label, weight: 'normal', color: null }}
            />
          </div>
        ))}
      </div>
      <div className='flex flex-wrap space-x-1 md:space-x-6 md:order-2'>
        {payments?.items?.map((payment) => (
          <div className='mb-2'>
            <Image
              {...payment}
              width='50px'
            />
          </div>
        ))}
      </div>
    </div>
  </>
);
